var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[(_vm.environment)?_c('PC'):_c('WEB')],1)}
var staticRenderFns = []

export { render, staticRenderFns }